import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";
import { ProductWrapperValuation } from "../../../../../../Wrap/Models/Models/Business/AssetUnderManagement/ProductWrapperValuation";
import { ProductUnderlyingAccountValuationCollectionModel } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Valution/ProductUnderlyingAccountValuationCollectionModel";
import { Table } from "../../../../../Shared/Table/Table";
import { subAccountTypeMap } from "../../../Clients/PortfolioDashboard/Components/Performance/Resource/Contents";
import { Urls } from "../../../../Urls";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { WithDrawalReview } from "../../../Clients/Common/Review/Component/WithDrawalReview";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { string } from "prop-types";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";

interface IProductPopupProps {
    isShow: boolean;
    data: ProductUnderlyingAccountValuationCollectionModel;
    productData: ProductWrapperValuation;
    isLoading: boolean;
    onChangePage: (min, max) => void;
    onClose: () => void;
}

export const ProductPopup = (props: IProductPopupProps) => {
    const [curPage, setCurPage] = React.useState(1);
    if (!props.data || !props.data.PageOfResults || !props.productData) {return null;}

    return (
        <>
            {props.isShow && (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    show={props.isShow}
                    onClose={() => props.onClose()}
                    title={subAccountTypeMap[props.productData?.ProductType]}
                >
                    <PartLoading isLoading={props.isLoading}>
                        <Table
                            data={props.data.PageOfResults.sort((a, b) => (a.Name > b.Name ? 1 : -1))}
                            col={[
                                {
                                    title: "Client name",
                                    key: "Name",
                                    render: (data, row) => {
                                        return (
                                            <button
                                                className="hyperlink"
                                                onClick={() => {
                                                    CommonHelper.isNullOrEmpty(row.CustomerHierarchyId)
                                                        ? Navigator.navigateTo(
                                                              Urls.get().main.PortfolioDashboard({
                                                                  hierarchyId: row.HierarchyId,
                                                              }).summary
                                                          )
                                                        : Navigator.navigateTo(
                                                              Urls.get().main.PortfolioDashboard({
                                                                  hierarchyId: row.CustomerHierarchyId,
                                                              }).summary
                                                          );
                                                }}
                                            >
                                                {row.Name}
                                            </button>
                                        );
                                    },
                                },
                                {
                                    title: "Account",
                                    key: "ClAccountId",
                                    tdCssWrapper: "cell-left",
                                    thCssWrapper: "cell-left",
                                    render: (data, row) => {
                                        return (
                                            <button
                                                className="hyperlink"
                                                onClick={() => {
                                                    CommonHelper.isNullOrEmpty(row.CustomerHierarchyId)
                                                        ? Navigator.navigateTo(
                                                              Urls.get().main.PortfolioDashboard({
                                                                  hierarchyId: row.HierarchyId,
                                                              }).summary
                                                          )
                                                        : Navigator.navigateTo(
                                                              Urls.get().main.PortfolioDashboard({
                                                                  hierarchyId: row.CustomerHierarchyId,
                                                              }).summary
                                                          );
                                                }}
                                            >
                                                {row.ClAccountId}
                                            </button>
                                        );
                                    },
                                },
                                {
                                    title: "Value",
                                    key: "Value",
                                    tdCssWrapper: "cell-right",
                                    thCssWrapper: "cell-right",
                                    render: (data, row, index) => {
                                        return MoneyDisplayHelper.getMoneyFormat(data);
                                    },
                                },
                            ]}
                            TotalBody={[
                                { data: "Total", colSpan: 2 },
                                {
                                    data: MoneyDisplayHelper.getMoneyFormat(props.productData.Value),
                                    tfTdCssWrapper: "cell-right",
                                },
                            ]}
                            needPagination={{
                                totalNumOfResult: props.data.TotalNumberOfResults,
                                onPaginationChange: (pageIndex, pageSize) => {
                                    setCurPage(pageIndex);
                                    props.onChangePage((pageIndex - 1) * 10 + 1, pageIndex * 10);
                                },
                                currentPage: curPage,
                            }}
                            showEmptyMsg={true}
                        />
                    </PartLoading>
                </Lightbox>
            )}
        </>
    );
};
